/**
 * Удаляет указанные ключи из объекта
 * @template T - Тип исходного объекта
 * @param {T} initObject - Исходный объект, из которого нужно удалить ключи
 * @param {(keyof T)[]} clear - Массив ключей, которые необходимо удалить
 * @returns {Partial<T>} Новый объект без указанных ключей
 */
export function clearObject<T extends object>(initObject: T, clear: (keyof T)[]): Partial<T> {
  const result = { ...initObject };

  clear.forEach(key => {
    delete result[key];
  });

  return result;
}
